<template>
  <div>
    <div
      class="catchClickIfItsOutside"
      v-if="isDropdownVisibil"
      @click="toggleMenu"
    ></div>
    <modal
      style="modal"
      class="modal-settings"
      name="settings-modal"
      :width="modalWidth"
      height="auto"
      :pivot-y="0.5"
      :scrollable="true"
      :clickToClose="true"
      @before-close="beforeClose"
    >
      <div class="box">
        <Settings :downloadsPossible="downloadsPossible" />
      </div>
    </modal>
  </div>
</template>

<script>
import Settings from "./Main";
export default {
  name: "SettingsModal",
  data() {
    return {
      isDropdownVisibil: false,
      downloadsPossible: false
    };
  },
  components: {
    Settings
  },
  computed: {
    modalWidth() {
      if (window.innerWidth <= 575) {
        return "100%";
      } else {
        return "70%";
      }
    },
    isCachingOrDeleting() {
      return (
        this.$store.state.isCachingElements ||
        this.$store.state.isDeletingElements
      );
    }
  },
  methods: {
    chooseLanguage(lang) {
      if (this.chosenLanguages.includes(lang)) {
        this.chosenLanguages = this.chosenLanguages.filter(function(item) {
          return item !== lang;
        });
      } else {
        this.chosenLanguages.push(lang);
      }
    },
    openModal() {
      this.$modal.show("settings-modal");
    },
    setDownloadPossible() {
      this.downloadsPossible = true;
    },
    clickedToggleBtn() {
      this.isDropdownVisibil = !this.isDropdownVisibil;
    },
    toggleMenu() {
      var toggleBtn = document.getElementById("navbar-toggler-btn");
      toggleBtn.click();
    },
    beforeClose(event) {
      if (this.isCachingOrDeleting) {
        event.stop();
      }
    }
  },
  mounted() {
    document.addEventListener("swRegistered", this.setDownloadPossible);
  },
  beforeDestroy() {
    document.removeEventListener("swRegistered", this.setDownloadPossible);
  }
};
</script>

<style scoped>
.box {
  background: white;
}
.modal-settings {
  z-index: 1040;
  height: 100% !important;
  min-height: 100% !important;
  overflow-y: auto;
}
.v--modal-overlay {
  z-index: 1040;
}
.catchClickIfItsOutside {
  position: fixed;
  bottom: 0;
  top: 0;
  right: 0;
  left: 0;
  background-color: transparent;
  z-index: 2;
}
</style>
